exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rainImg[data-v-fb47e720]{position:fixed;display:block;z-index:2000;top:-100px;animation:rain 5s ease-in}@keyframes rain{0%{top:-100px}to{top:120%}}#redrainfails[data-v-fb47e720]{text-align:center;font-size:16px;color:#666;padding:10px 0}#redrainfails img[data-v-fb47e720]{width:100px}#redrainSuccess[data-v-fb47e720]{margin:-10px;background:#fff;text-align:center}#redrainSuccess .title[data-v-fb47e720]{background-color:#e9251e;padding:15px;color:#fff}#redrainSuccess .money[data-v-fb47e720]{padding:28px;font-family:Impact;font-size:29px;color:#393939}#redrainSuccess .mannum[data-v-fb47e720]{color:#696969;padding-bottom:30px}#redrainSuccess .mannum span[data-v-fb47e720]{color:#e9251e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-fb47e720","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/redRain.vue
// module id = 350
// module chunks = 0